export const BACKEND_URL = process.env.REACT_APP_API_URL;
export const API_BASE_URL = process.env.REACT_APP_DD_API_URL;
